import { loadQuill } from '@vueup/vue-quill'

// Three short lines with leading dashes, matching Quill's own list icons
const DASH_LIST_ICON =
  '<svg viewBox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="2" x2="4" y1="4" y2="4"/><line class="ql-stroke" x1="2" x2="4" y1="9" y2="9"/><line class="ql-stroke" x1="2" x2="4" y1="14" y2="14"/></svg>'

// A dash list next to Quill's ordered and bullet lists: its toolbar button needs an icon.
// Quill loads lazily; this runs before the editors waiting for the same load build toolbars.
export default defineNuxtPlugin(() => {
  loadQuill().then((Quill) => {
    const icons = Quill.import('ui/icons')
    if (icons && typeof icons === 'object' && 'list' in icons && icons.list) {
      Object.assign(icons.list, { dash: DASH_LIST_ICON })
    }
  })
})
